import React, { useEffect } from "react";
import { Form, Button, Input, DatePicker, Checkbox } from "antd";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";
import FormItem from "../../../../components/fields/FormItem";
import { requiredField } from "utils/crudSagaHelper";



function SkillList({
    name = "work_experience",
    label = "Work Experience",
    dataList = [],
    minItems = 1,
    maxItems,
    addButtonClass,
    mode = "edit",
    labelExtra,
    icon: Icon,
    listClass = "list-1-column",
    applicantId,
}) {
    const form = Form.useFormInstance();

    const emptySkill = {
        ask_id: 0,
        ask_applicant_id: applicantId || null,
        ask_description: "",
    };

    const initialData = dataList && dataList.length > 0
            ? dataList
            : [emptySkill];

    useEffect(() => {
        if (form && mode !== "view") {
            const currentValues = form.getFieldValue(name);

            if (!currentValues || currentValues.length === 0) {
                form.setFieldValue(name, [emptySkill]);
            }
        }
    }, [form, name, mode]);

    return (
        <Form.List
            name={name}
            initialValue={[initialData]}
            rules={[
                requiredField(),
                {
                    validator: async (_, value) => {
                        if (!value || value.length < minItems) {
                            return Promise.reject(
                                new Error(
                                    `At least ${minItems} skills required`
                                )
                            );
                        }

                        return Promise.resolve();
                    },
                },
            ]}
        >
            {(fields, { add, remove }, { errors }) => (
                <>
                    <div className="flex items-center gap-1 mb-2">
                        {Icon && <Icon className="w-4 h-4" />}
                        <span className="text-sm">{label}</span>
                        {labelExtra}
                    </div>

                    <div className={`grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 ${listClass}`}>
                        {fields.map(({ key, name: fieldName, ...restField }, index) => {

                            return (
                                <div key={key} className="flex gap-2 justify-between items-center">
                                    <FormItem
                                        name={[fieldName, "ask_id"]}
                                        hidden
                                    >
                                        <Input type="hidden"/>
                                    </FormItem>
                                    
                                    <FormItem
                                        {...restField}
                                        name={[fieldName, "ask_description"]}
                                        noStyle
                                    >
                                        <Input
                                            className="input-field"
                                            placeholder="Enter skill"
                                            readOnly={mode !== "edit"}
                                        />
                                    </FormItem>
                                    
                                    {mode === "edit" && fields.length > minItems && (
                                        <MinusCircleOutlined
                                            className="text-gray-500 dark:text-white cursor-pointer"
                                            onClick={() => remove(fieldName)}
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>

                    <Form.ErrorList errors={errors} className="mb-2 text-red-500" />

                    {mode === "edit" && (!maxItems || fields.length < maxItems) && (
                        <FormItem>
                            <Button
                                type="dashed"
                                onClick={() => add(emptySkill)}
                                icon={<PlusOutlined />}
                                className={addButtonClass}
                            >
                                Add skill
                            </Button>
                        </FormItem>
                    )}
                </>
            )}
        </Form.List>
    );
}

export default SkillList;